module.exports = {
	"Announcement": {
		"Know More": "Saiba mais"
	},
	"Appointment": {
		"Conditions": "Ao clicar em “Confirmar”, você confirma ter lido a Política de Privacidade e concorda com o processamento de seus dados pessoais por parte da %(brand)s, de acordo com as condições estabelecidas na Política de Privacidade, para responder à sua solicitação.",
		"Confirmation": "Recebemos seu pedido de agendamento de visita à boutique com um de nossos consultores para um atendimento personalizado. Você receberá um e-mail de confirmação em breve.",
		"Description": "A Dior convida você a marcar uma visita na boutique com um de nossos consultores para um atendimento personalizado.",
		"Get an appointment": "Marcar uma visita",
		"Motives": "Motivos",
		"Universes": "Universo"
	},
	"DiorMap": {
		"Search in this area": "Busque nesta área"
	},
	"FilterBlock": {
		"%(count)s Results": {
			"one": "%(count)s Resultado",
			"other": "%(count)s Resultados",
			"zero": "%(count)s Resultado"
		},
		"Refine": "Refinar",
		"RefineAria": "Afine sua busca selecionando os campos abaixo",
		"Are you looking for?": "Procura uma boutique relacionada com o universo da Moda Feminina, Masculina, Infantil, Joalheria ou Relojoaria?"
	},
	"Footer": {
		"Download the applications": "Baixar os aplicativos",
		"Language": "Idioma",
		"Newsletter": "Ex.: Christian@dior.fr",
		"Ok": "OK",
		"Subscribe to newsletter": "Inscrever-se na Newsletter"
	},
	"Form": {
		"All fields are mandatory": "Todos os campos são obrigatórios",
		"Civility": "Título",
		"Comments": "Comentários",
		"Conditions": "Para receber uma confirmação por e-mail da %(brand)s, marque a opção acima. Você dispõe do direito à acessar, retificar, apagar e opor-se ao processamento dos dados pessoais que lhe dizem respeito, para exercer esse direito escreva a \"contact@dior.com\"",
		"Date": "Preferência de data ",
		"Email": "E-mail",
		"Hour": "Preferência de horário",
		"Invalid E-mail address": "Endereço de email invalido",
		"Mr": "Sr.",
		"Mrs": "Sra.",
		"Name": "Sobrenome",
		"Phone": "Telefone",
		"Required fields": "Os campos obrigatórios",
		"Submit": "Validar",
		"Surname": "Nome"
	},
	"HeaderLight": {
		"Dior Boutiques near you: haute couture, fragrances, leather goods": "Boutiques Dior na sua cidade: alta costura, perfumes, marroquinaria",
		"Search for Dior shops": "Search for Dior shops",
		"Dior home logo": "DIOR home logo",
		"close boutique finder dialog": "close boutique finder dialog"
	},
	"Itinerary": {
		"Arrival": "Destino",
		"Departure": "Origem",
		"Details": "Detalhes",
		"Error": "Infelizmente não foi possível calcular o itinerário solicitado. Tenta novamente com outro endereço de partida e/ou meio de transporte",
		"Follow the itinerary": "Seguir o itinerário",
		"Itinerary": "Itinerário",
		"modeBICYCLING": "Ir de bicicleta",
		"modeDRIVING": "Ir de carro",
		"modeTRANSIT": "Ver trânsito",
		"modeWALKING": "Ir a pé",
		"Close dialog": "close dialog",
		"Print directions": "print directions"
	},
	"LayerOrientation": {
		"Use portrait": "Use seu telefone no modo retrato"
	},
	"NavMobile": {
		"Home": "Página inicial"
	},
	"Newsletter": {
		"Dior Newsletter": "Newsletter Dior",
		"Fashion and accessories": "Moda & Acessórios",
		"I wish to receive the %(newsletter)s newsletter": "Quero receber as novidades em %(newsletter)s",
		"Newsletter Confirmation": "Você foi devidamente inscrito(a) em nossa newsletter",
		"Perfume and beauty": "Perfume & Cosméticos",
		"Receive our newsletter": "Receba a nossa newsletter",
		"Your universes": "Seus universos"
	},
	"ResultsBlock": {
		"Dior boutiques": "Boutiques Dior",
		"Too far": "Foram encontrados muitos resultados. refine sua busca, selecionando uma área de pequisa menor.",
		"No result": "Nenhuma boutique foi encontrada",
		"Other shops": "Outras boutiques",
		"Results": "Resultados da busca",
		"Fewer results, zoom in": "Menos resultados, zoom in",
		"More results, zoom out": "Mais resultados, zoom out",
		"Fewer results": "Menos resultados",
		"More results": "Mais resultados"
	},
	"SearchBlock": {
		"Geolocation": "Utilize a geolocalização para encontrar a boutique mais próxima",
		"Search": "Buscar"
	},
	"Share": {
		"Conditions": "Para receber uma confirmação por e-mail da %(brand)s, marque a opção acima. Você dispõe do direito à acessar, retificar, apagar e opor-se ao processamento dos dados pessoais que lhe dizem respeito, para exercer esse direito escreva a \"contact@dior.com\"",
		"Recipient": "Seu destinatário",
		"Share Confirmation": "A ficha de sua boutique foi enviada com sucesso",
		"Share this shop": "Compartilhar os detalhes da boutique",
		"Your favorite shop": "Sua boutique favorita"
	},
	"ShopBlock": {
		"Closed": "Fechada",
		"Closed today": "Fechada hoje",
		"Directions": "Itinerário",
		"DirectionsAria": "Itinerário para a %(shopName)s",
		"Make an appointment": "Marcar uma visita",
		"Open": "Aberto",
		"Opening time": "Horários de abertura",
		"OpeningAria": "Mais informações sobre os horários de funcionamento.",
		"ResultNumber": "Resultado número %(number)s",
		"Services": "Serviços",
		"ServicesAria": "Mais informações sobre os serviços",
		"Share": "Compartilhar",
		"Special hours": "Special hours",
		"Today until %(hour)s": "Hoje até as %(hour)s",
		"Universes": "Universo",
		"UniversesAria": "Mais informações sobre os universos relacionados",
		"and": "and",
		"from": "from",
		"publicHolidays": "A boutique encontra-se provavelmente fechada",
		"to": "to"
	}
};


//////////////////
// WEBPACK FOOTER
// ./public/assets/locales/pt_br/translations.json
// module id = 872
// module chunks = 0